module.exports = __webpack_public_path__ + "img/logo.be417a35.svg";